import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { getListKunjunganByGroup } from "stores";
import { showUrlDokumenKunjungan } from "stores";
import { ColorRing, Dna, Watch } from "react-loader-spinner";
import { showUrlBuktiKunjungan } from "stores";
import GoogleMapReact from "google-map-react";

function ListKunjunganByGroup(data) {
  //   console.log(data, "DATAA");
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  const urlPreview = korcab.urlDokumenKunjungan;
  const handleClick = () => {
    dispatch({ type: "SET_KUNJUNGAN_BY_GROUP", data: true });
  };
  // console.log(korcab, "KORCAB");
  const [listKunjunganPerGroup, setListKunjunganPerGroup] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  //   const [searchText, setSearchText] = React.useState("");
  const [modalDetails, setModalDetails] = React.useState(false);
  const [detailKunjungan, setDetailKunjungan] = React.useState([]);
  const [buktiKunjungan, setBuktiKunjungan] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };
  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const handleClickKunjungan = (val) => {
    setModalDetails(!modalDetails);
    setDetailKunjungan(val);
    setLoading(true); // Mulai loading
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setBuktiKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      })
    );
    setLatitude(parseFloat(val.lat));
    setLongitude(parseFloat(val.long));
  };
  React.useEffect(() => {
    let tmp =
      korcab.listDataKunjunganByGroup.docs &&
      korcab.listDataKunjunganByGroup.docs.map((val) => {
        return {
          ...val,
          action: (
            <>
              {" "}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Group Kunjungan</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#30B9FB",
                    border: 0,
                  }}
                  // onClick={() => {
                  //   console.log(val);
                  //   setModalDetails(true);

                  // }}
                  onClick={() => handleClickKunjungan(val)}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
            </>
          ),
        };
      });
    setListKunjunganPerGroup(tmp);
  }, [korcab.listDataKunjunganByGroup]);

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt"></i> {text}
    </div>
  );

  const defaultProps = {
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 11,
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case "Progress":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDE5DD",
          textColor: "#F85317",
        };
      case "Done":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "Perhitungan Minus":
        return {
          fontWeight: "bold",
          backgroundColor: "#F2E6FF",
          textColor: "#7F00FF",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        height: 50, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const colGroupKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      // selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      selector: (row, index) => index + korcab.groupKujunganById.pagingCounter,
    },
    {
      name: "ID Group Kunjungan",
      minWidth: "290px",
      center: true,
      selector: (row) => row.idGroupKunjungan,
    },
    {
      name: "ID Pinjaman",
      minWidth: "290px",
      center: true,
      selector: (row) => (row.bapLoan === "" ? "-" : row.bapLoan),
    },
    {
      name: "Tgl Kunjungan",
      minWidth: "150px",
      center: true,
      selector: (row) => moment(row.tglKunjungan).format("DD MMMM YYYY"),
    },
    {
      name: "Cabang",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.cabang ? "-" : row.cabang.namaCabang),
    },
    {
      name: "Area Manager",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.areaManager ? "-" : row.areaManager.nama),
    },
    {
      name: "Supervisor",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.supervisor ? "-" : row.supervisor.nama),
    },
    {
      name: "Marketing",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.marketing ? "-" : row.marketing.nama),
    },
    {
      name: "Koor Cabang",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.korcab ? "-" : row.korcab.nama),
    },
    {
      name: "Nett",
      minWidth: "180px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.nett);
        return formattedValue;
      },
    },
    {
      name: "Keputusan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.keputusan,
      cell: (row) => {
        const statusStyle = getKeputusan(row.keputusan);
        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {row.keputusan}
          </div>
        );
      },
    },
    {
      name: "Hasil",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hasil,
      cell: (row) => {
        const hasil =
          row.hasil === ""
            ? "-"
            : row.hasil === "Perhitungan minus"
            ? "Perhitungan Minus"
            : row.hasil;
        const statusStyle = getHasil(hasil);
        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {hasil}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getListKunjunganByGroup(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      idGroup: data.data,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      <Modal
        size="xl"
        show={modalDetails}
        onHide={() => {
          // handleModalClose();
          setModalDetails(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12">
          <Card.Title
            as="h4"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              fontFamily: "sans-serif",
              marginLeft: 13,
              textAlign: "center",
            }}
          >
            detail kunjungan
            <hr></hr>
          </Card.Title>
          <Card
            className="stacked-form"
            style={{ border: 0, overflowY: "scroll", maxHeight: "700px" }}
          >
            <Card.Body>
              <Form action="#" method="#">
                <ul style={{ paddingLeft: "1.2rem" }}>
                  {" "}
                  {/* biar listnya agak masuk */}
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          Tanggal Kunjungan
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {moment(detailKunjungan.tglKunjungan).format(
                            "DD MMMM YYYY"
                          )}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          plafond
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {formatRupiah(detailKunjungan.plafond)}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          nett
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {formatRupiah(detailKunjungan.nett)}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          keputusan
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color:
                              detailKunjungan.keputusan === "Tunda"
                                ? "#FF7F00"
                                : detailKunjungan.keputusan === "Batal"
                                ? "#B0054B"
                                : detailKunjungan.keputusan === "Disetujui"
                                ? "#87CB16"
                                : "#FF0000",
                            fontWeight: "bold",
                          }}
                        >
                          {detailKunjungan.keputusan === ""
                            ? "-"
                            : detailKunjungan.keputusan}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          hasil
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color:
                              detailKunjungan.hasil === "Batal"
                                ? "#B0054B"
                                : detailKunjungan.hasil === "Pinjam"
                                ? "#1569C7"
                                : detailKunjungan.hasil === "Perhitungan Minus"
                                ? "#7F00FF"
                                : "#000000",
                            fontWeight: "bold",
                          }}
                        >
                          {detailKunjungan.hasil === ""
                            ? "-"
                            : detailKunjungan.hasil}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          wilayah
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {detailKunjungan.wilayah
                            ? detailKunjungan.wilayah.namaWilayah
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          area manager
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {detailKunjungan.areaManager
                            ? detailKunjungan.areaManager.nama
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          supervisor
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {detailKunjungan.supervisor
                            ? detailKunjungan.supervisor.nama
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          marketing
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {detailKunjungan.marketing
                            ? detailKunjungan.marketing.nama
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          koordinator cabang
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {detailKunjungan.korcab
                            ? detailKunjungan.korcab.nama
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          keterangan
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {detailKunjungan.keterangan === ""
                            ? "-"
                            : detailKunjungan.keterangan}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          foto kunjungan
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          {buktiKunjungan ? (
                            // <img
                            //   src={
                            //     urlPreview + "?test=" + new Date().getTime().toString()
                            //   }
                            //   alt="Bukti Kunjungan"
                            //   style={{ maxWidth: "60%", maxHeight: "50%" }}
                            // />
                            loading ? (
                              <>
                                <div
                                  className="loader-container"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="color-ring-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="color-ring-wrapper"
                                    colors={[
                                      "#6c757d",
                                      "#6c757d",
                                      "#6c757d",
                                      "#6c757d",
                                      "#6c757d",
                                    ]}
                                  />
                                  <p
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: 19,
                                    }}
                                  ></p>
                                </div>
                              </>
                            ) : (
                              <img
                                src={urlPreview}
                                alt="Bukti Kunjungan"
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                            )
                          ) : (
                            <>
                              <div style={{ marginBottom: "1rem" }}>
                                <div
                                  style={{
                                    backgroundColor: "#E0D5FA",
                                    color: "#703BE7",
                                    borderRadius: "8px",
                                    padding: "10px 15px",
                                    boxShadow: "0 3px 8px rgba(0, 1, 0, 0.3)",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  Maaf, masih belum ada bukti Kunjungan untuk
                                  saat ini..
                                </div>
                              </div>
                              <img
                                src={require("assets/img/sorry.jpg").default}
                                alt="Sorry"
                                style={{ maxWidth: "50%", borderRadius: "5px" }}
                              />
                            </>
                          )}
                        </label>
                      </Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm="3">
                        <label
                          style={{
                            textTransform: "capitalize",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          lokasi
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        {/* <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        > */}
                        <div
                          style={{
                            height: "50vh",
                            width: "100%",
                            margin: "auto",
                          }}
                        >
                          <GoogleMapReact
                            bootstrapURLKeys={{
                              key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                            }}
                            center={{
                              lat: latitude || defaultProps.center.lat,
                              lng: longitude || defaultProps.center.lng,
                            }}
                            defaultZoom={defaultProps.zoom}
                          >
                            {latitude !== null && longitude !== null && (
                              <AnyReactComponent
                                lat={latitude}
                                lng={longitude}
                                // text="My Marker"
                              />
                            )}
                          </GoogleMapReact>
                        </div>
                        {/* </label> */}
                      </Col>
                    </Row>
                  </li>
                </ul>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Modal>

      <Container fluid>
        <Button
          className="btn-transparent mr-2"
          type="button"
          variant="primary"
          size="md"
          style={{
            border: "none",
            backgroundColor: "#F75D59",
            marginBottom: 20,
            border: 0,
          }}
          onClick={handleClick}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title
                  // as="h3"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    textAlign: "center",
                    fontSize: 25,
                  }}
                >
                  kunjungan per group
                  <hr></hr>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                {isLoading ? (
                  <div
                    className="loader-container"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "30vh",
                    }}
                  >
                    <Watch
                      visible={true}
                      height="80"
                      width="80"
                      radius="30"
                      color="#F75D59"
                      ariaLabel="watch-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                    <p>Loading...</p>
                  </div>
                ) : (
                  <div>
                    {listKunjunganPerGroup.length > 0 ? (
                      <DataTable
                        columns={colGroupKunjungan}
                        data={listKunjunganPerGroup}
                        customStyles={customStyles}
                        paginationPerPage={totalPerHalaman}
                        //   progressPending={isLoading}
                      />
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginBottom: "1rem",
                            fontSize: 17,
                          }}
                        >
                          Maaf, belum ada detail kunjungan nasabah saat ini.
                        </p>
                        <img
                          src={require("assets/img/sorry.jpg").default}
                          alt="Sorry"
                          style={{
                            maxWidth: "20%",
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </div>
                    )}
                    <div style={{ marginTop: 35 }}>
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Col md={4}>
                          <Row style={{ alignItems: "center" }}>
                            <div
                              style={{
                                paddingRight: 0,
                                marginLeft: 20,
                                marginRight: 10,
                              }}
                            >
                              <label style={{ fontWeight: "bold" }}>
                                Rows per page
                              </label>
                            </div>
                            <Col md="4" style={{ paddingLeft: 0 }}>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="Pilih Client"
                                value={options.find(
                                  (option) => option.value === totalPerHalaman
                                )}
                                onChange={handlePageSizeChange}
                                options={options}
                                placeholder="Rows per page"
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <ReactPaginate
                            forcePage={page}
                            containerClassName="paginations justify-content-end"
                            previousClassName="pages-items-containers"
                            previousLinkClassName="pages-links-labels"
                            nextClassName="pages-items-containers"
                            nextLinkClassName="pages-links-labels"
                            breakClassName="pages-items-containers"
                            pageCount={
                              korcab.listDataKunjunganByGroup.totalPages
                            }
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={1}
                            pageLinkClassName="pages-links-labels"
                            pageClassName="pages-items-containers"
                            activeClassName="actives"
                            activeLinkClassName="activess"
                            nextLabel=" > "
                            previousLabel=" < "
                            initialPage={page}
                            disableInitialCallback={true}
                            onPageChange={(val) => {
                              setPage(val.selected);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </Card.Body>
              {/* <Card.Body>
                <DataTable
                  columns={colGroupKunjungan}
                  data={listGroup}
                  customStyles={customStyles}
                  paginationPerPage={totalPerHalaman}
                  //   progressPending={isLoading}
                />
                <div style={{ marginTop: 35 }}>
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Col>
                      <Row style={{ alignItems: "center" }}>
                        <div
                          style={{
                            paddingRight: 0,
                            marginLeft: 20,
                            marginRight: 10,
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Rows per page
                          </label>
                        </div>
                        <Col sm="3" style={{ paddingLeft: 0 }}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="Pilih Client"
                            value={options.find(
                              (option) => option.value === totalPerHalaman
                            )}
                            onChange={handlePageSizeChange}
                            options={options}
                            placeholder="Rows per page"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Card.Body> */}
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListKunjunganByGroup;
